<script>
export default {
    name: "BaseMirIcon"
}
</script>

<template>
    <svg width="58" height="24" viewBox="0 0 58 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.73584 4.50244H6.89125C7.35992 4.50244 8.76595 4.34622 9.39084 6.53336C9.85952 7.93938 10.4844 10.1265 11.4218 13.4072H11.7342C12.6716 9.9703 13.4527 7.62693 13.7651 6.53336C14.39 4.34622 15.9523 4.50244 16.5772 4.50244H21.4201V19.5H16.4209V10.5952H16.1085L13.4527 19.5H9.70329L7.04748 10.5952H6.5788V19.5H1.73584M23.4511 4.50244H28.4502V13.4072H28.9189L32.1996 6.06469C32.8245 4.65867 34.2305 4.50244 34.2305 4.50244H38.9173V19.5H33.9181V10.5952H33.6057L30.3249 17.9378C29.7 19.3438 28.1378 19.5 28.1378 19.5H23.4511M45.6349 14.9695V19.5H40.9482V11.6888H56.2582C55.6333 13.5635 53.4462 14.9695 50.9466 14.9695" fill="#0F754E"/>
        <path d="M56.5705 10.749C57.1954 7.93694 55.3207 4.5 51.2589 4.5H40.6356C40.9481 7.78072 43.7601 10.749 46.7284 10.749" fill="url(#paint0_linear_59388_785)"/>
        <defs>
            <linearGradient id="paint0_linear_59388_785" x1="54.6958" y1="2.46908" x2="42.1979" y2="2.46908" gradientUnits="userSpaceOnUse">
                <stop stop-color="#1F5CD7"/>
                <stop offset="1" stop-color="#02AEFF"/>
            </linearGradient>
        </defs>
    </svg>
</template>

<style scoped>

</style>
